module.exports = __webpack_public_path__ + "static/img/9bac.0674da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/9bac.jpg
// module id = 0+Au
// module chunks = 1